import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ccd60a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "relative h-full"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "payment-element" }, null, -1))
const _hoisted_3 = {
  key: 1,
  class: "fade-in"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColorButton = _resolveComponent("ColorButton")!

  return (_ctx.showPayButton)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_ColorButton, {
          text: _ctx.$t('pay'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.razorpayCheckout($event))),
          class: "md:mt-8 sm:mt-4 forceWhite"
        }, null, 8, ["text"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("connecting_to_bank")), 1)
      ]))
}